import { prefix } from "../../js/utilities";
import { actions, events } from "../../js/state-machine";
import { closeX } from "../../js/helpers/built-in-icons";
import { matchers } from "../../js/validate-props";

export const componentName = "MessageBar";

export const styleShowing = `${prefix}showing`;
export const styleHiding = `${prefix}hiding`;

export const defaultProps = Object.freeze({
    dismissible: true,
    srCloseLabel: "close dialog",
    timer: false,
    timerDuration: 5,
});

export const schema = Object.freeze({
    dismissible: matchers.boolean,
    srCloseLabel: matchers.minChars(1),
    timer: matchers.boolean,
    timerDuration: matchers.gte(1),
});

export const eventMap = Object.freeze({
    // @deprecated
    opening: events.opening(componentName),
    closing: events.closing(componentName),
    visible: events.opened(componentName),
    closed: events.closed(componentName),

    [actions.show().type]: events.showing(componentName),
    [actions.hide().type]: events.hiding(componentName),
    // When animation is finished
    shown: events.shown(componentName),
    hidden: events.hidden(componentName),
});

export const componentClasses = Object.freeze({
    messageBar: {
        base: `${prefix}message-bar`,
        alignment: `${prefix}message-bar__content--center`,
        content: `${prefix}message-bar__content`,
        icon: `${prefix}message-bar__icon`,
        global: `${prefix}message-bar--global`,
        globalContainer: `${prefix}message-bar--global__container`,
        success: `${prefix}message-bar--success`,
        warning: `${prefix}message-bar--warning`,
        error: `${prefix}message-bar--error`,
        hide: `${prefix}message-bar--hide`,
    },
    activeTimer: `${prefix}message-bar--timer-active`,
    closeButton: `${prefix}message-bar__dismiss`,
    hasTimer: `${prefix}message-bar--timer`,
    timerButton: `${prefix}message-bar__dismiss__timer`,
});

export const views = Object.freeze({
    visible: {
        classList: [`!${styleShowing}`, `!${styleHiding}`, `!${componentClasses.messageBar.hide}`],
        attrs: { "aria-hidden": null, "aria-live": "polite", "aria-role": "alert" },
    },
    showing: {
        classList: [styleShowing, `!${componentClasses.messageBar.hide}`],
    },
    hiding: {
        classList: [styleHiding],
    },
    hidden: {
        classList: [
            // Need to add the hidden styles before we remove the hiding styles, otherwise we get a flicker when bar is closed.
            componentClasses.messageBar.hide,
            `!${styleHiding}`,
            `!${componentClasses.activeTimer}`,
        ],
        attrs: { "aria-hidden": "true" },
    },
});

export const icons = Object.freeze({
    close: closeX,
});

export const svgs = Object.freeze({
    dismissTimer: `<svg class="${prefix}message-bar__timer"><circle class="${prefix}message-bar__timer-circle" cx="13" cy="13" r="12" /></svg>`,
});
